import { usePathname } from 'lib/i18n/routing'
import { Subnav } from 'components/subnav'
import { useLocale } from 'next-intl'

export default function PartnersSubnav() {
	const pathname = usePathname()
	const locale = useLocale()

	return (
		<Subnav
			locale={locale}
			titleLink={{ text: 'Partners', url: '/partners' }}
			currentPath={pathname}
			menuItems={[
				{ text: 'Overview', url: '/partners' },
				{ text: 'Find a partner', url: '/partners/find-a-partner' },
				{ text: 'Become a partner', url: '/partners/become-a-partner' },
			]}
			ctaLinks={[
				{
					text: 'Partner Portal',
					href: 'https://hashicorpcommunity.force.com/PartnerCommunity',
				},
			]}
		/>
	)
}
